import { render, staticRenderFns } from "./OnlinePayHeaderV2.vue?vue&type=template&id=f066a9ee&scoped=true&"
import script from "./OnlinePayHeaderV2.vue?vue&type=script&lang=ts&"
export * from "./OnlinePayHeaderV2.vue?vue&type=script&lang=ts&"
import style0 from "./OnlinePayHeaderV2.vue?vue&type=style&index=0&id=f066a9ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f066a9ee",
  null
  
)

export default component.exports